export const SUPPORT_EMAIL =
  process.env.REACT_APP_SUPPORT_EMAIL || 'support@techelliptica.com';

export const SUPPORT_PHONE =
  process.env.REACT_APP_SUPPORT_PHONE || '73873 11899';

export const SUPPORT_PHONE_TEL =
  process.env.REACT_APP_SUPPORT_PHONE_TEL || '+917387311899';

export const POWERED_BY = 'TechElliptica';

export const OFFICE_ADDRESS =
  'Office Number 119, Mainland Hub, Kesnand Rd, near Mainland Valencia, Wagholi, Pune, Maharashtra 412207';

export const BUSINESS_HOURS = {
  days: 'Monday - Friday',
  time: '9:00 AM - 6:00 PM IST',
};

export const GOOGLE_MAPS_DIRECTIONS_URL =
  'https://www.google.com/maps/dir//TechElliptica,+Office+Number+119,+Mainland+Hub,+Kesnand+Rd,+near+Mainland+Valencia,+Wagholi,+Pune,+Maharashtra+412207/@18.5764157,73.994756,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bc2c3da725b5f89:0x89ce0af4435fd0a8!2m2!1d73.9992977!2d18.577134?entry=ttu';

export const GOOGLE_MAPS_EMBED_URL =
  'https://maps.google.com/maps?q=18.577134,73.9992977&hl=en&z=15&output=embed';
